// extracted by mini-css-extract-plugin
export var avatarContainer = "_ao-0";
export var avatarTypingWave = "_ao-i";
export var gray = "_ao-f";
export var green = "_ao-c";
export var icon = "_ao-9";
export var image = "_ao-1";
export var lg = "_ao-6";
export var md = "_ao-5";
export var presenceDot = "_ao-b";
export var red = "_ao-d";
export var sm = "_ao-4";
export var status = "_ao-a";
export var typingDot = "_ao-h";
export var typingPill = "_ao-g";
export var xl = "_ao-7";
export var xs = "_ao-3";
export var xxl = "_ao-8";
export var xxs = "_ao-2";
export var yellow = "_ao-e";